import { schema } from 'normalizr';

const COUNTER_LINE_SCHEMA = new schema.Entity('counterLines', {}, { idAttribute: '@id' });

export default {
  CounterLine: COUNTER_LINE_SCHEMA,
};
